"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleRowLine = exports.ROW_DEPTH_INDENTATION = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
exports.ROW_DEPTH_INDENTATION = 20;
const CollapsibleRowLine = ({ height, depth, }) => ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
        boxSizing: "content-box",
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        height,
        width: 8,
        left: `${exports.ROW_DEPTH_INDENTATION * depth}px`,
        top: 0,
        zIndex: 1,
        pl: 1.25,
    }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            height: 1,
            width: "1px",
            background: ({ palette }) => palette.gray[30],
        } }) }));
exports.CollapsibleRowLine = CollapsibleRowLine;
